import React from 'react';

import Icon, { ICON_SIZES } from './Icon';

/**
 * Icon with title tooltip (web only).
 * On web, wraps icon in a div with title attribute for hover tooltip.
 */
const IconWithTitle = ({ title, icon, size = 'inline', weight, color }) => {
  return (
    <div title={title}>
      <Icon
        icon={icon}
        size={size}
        weight={weight}
        color={color}
        accessibilityLabel={title}
      />
    </div>
  );
};

export default IconWithTitle;
